module.exports = __webpack_public_path__ + "static/media/encore_logo_en.d61a9c2e.svg";